"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgesApi = void 0;
var tslib_1 = require("tslib");
var axios_1 = tslib_1.__importDefault(require("axios"));
var BadgesServiceUrl = '/_api/members-badges-server';
// https://bo.wix.com/wix-docs/rest/drafts/badges
var BadgesApi = /** @class */ (function () {
    /**
     * @param {string} token - jwt for site instance
     * (see [more](https://github.com/wix-private/platformization-guidelines/blob/master/guides/instance.md#instance))
     */
    function BadgesApi(token, apiBaseUrl) {
        this.token = token;
        // this.api = MembersBadgesServer(BadgesServiceUrl).BadgesService()({
        //   Authorization: token
        // });
        this.axios = axios_1.default.create({
            baseURL: apiBaseUrl + "/_api/members-badges-server/v1/badges",
            headers: {
                Authorization: token,
            },
        });
    }
    BadgesApi.prototype.getBadges = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var badgesMap, response, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        badgesMap = {};
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.axios.get('')];
                    case 2:
                        response = (_a.sent()).data;
                        // const response = await this.api.list({});
                        (response.badges || []).reduce(function (acc, badge) {
                            if (badge && badge.id) {
                                acc[badge.id] = badge;
                            }
                            return acc;
                        }, badgesMap);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.log('Error in BadgesApi.getBadges', e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, badgesMap];
                }
            });
        });
    };
    BadgesApi.prototype.getMembersBadgeIds = function (memberIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var membersBadgeIdsMap, response, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        membersBadgeIdsMap = {};
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.axios.post('/members', {
                                memberIds: memberIds,
                            })];
                    case 2:
                        response = (_a.sent()).data;
                        // const response = await this.api.listMembersBadgeIds({
                        //   memberIds
                        // });
                        (response.memberBadgeIds || []).reduce(function (acc, memberBadgeIds) {
                            if (memberBadgeIds.memberId && memberBadgeIds.badgeId) {
                                acc[memberBadgeIds.memberId] = memberBadgeIds.badgeId;
                            }
                            return acc;
                        }, membersBadgeIdsMap);
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        console.log('Error in BadgesApi.getMembersBadgeIds', e_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, membersBadgeIdsMap];
                }
            });
        });
    };
    return BadgesApi;
}());
exports.BadgesApi = BadgesApi;
//# sourceMappingURL=BadgesApi.js.map